// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_DeletaContaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for DELETE /contas/deleta_conta/{id}
 *
 * Echoes the soft-deleted conta_id. Wire shape preserves the legacy
 * `{ conta_id: int }` object emit.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contas_DeletaContaResponseDados {
conta_id: number
}

export type Contas_DeletaContaResponse = ApiResponse<Contas_DeletaContaResponseDados>;

registerResponseContract('Contas_DeletaContaResponse', {
  conta_id: { type: 'number',  required: true },
})
